import { useMutation } from '@tanstack/react-query';
import { priceCheck } from '../services/OrderService';
import type { OrderItemInput } from '../types/@types/order';

export function usePriceCheck() {
  return useMutation({
    mutationKey: ['orders', 'price-check'],
    mutationFn: (items: OrderItemInput[]) => priceCheck({ items }),
  });
}
